export const frSimulations = {
  start: 'Commencer la simulation',
  reloadForEquipmentWarning:
    'REMARQUE : Si du matériel manque, actualisez votre navigateur et recommencez.',
};
